import { createEntityFilterConfig } from '../../factories/create-entity-filter-config';
import leadReferalApi from '@src/features/leads/services/lead-referal-api';
import { STATIC_FILTER_ENTITY_TYPES } from '@shared/features/views/components/entities-filters/config';
import { LeadReferalFilterOptionItem } from './filter-option-item';
import { FILTER_COLOR } from '../filter-colors';

export const leadReferalFilterConfig = createEntityFilterConfig({
  facetName: 'referal',
  fetchInfiniteData: leadReferalApi.useFetchInfinite,
  entityType: STATIC_FILTER_ENTITY_TYPES.leadReferal,
  getValue: (item) => String(item.id),
  renderItem: LeadReferalFilterOptionItem,
  color: FILTER_COLOR.purple,
});
